import { useEffect } from 'react'
import { gsap, Power1 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import styles from './About.module.scss'
import TitleFlex from 'components/services/commons/TitleFlex'

gsap.registerPlugin(ScrollTrigger)

const tweenVars = {
  y: '50',
  duration: 0.5,
  opacity: 0,
  ease: Power1.easeOut,
}

interface Props {
  list: {
    text: string
  }[]
  explain?: {
    title?: string
    explanation?: string
  }[]
}

const About: React.FC<Props> = ({ list, explain }) => {
  const timeline = gsap.timeline()

  useEffect(() => {
    timeline
      .from('.About_item01', tweenVars, 0.3)
      .from('.About_item02', tweenVars, 0.6)
      .from('.About_item03', tweenVars, 0.9)
      .from('.About_item04', tweenVars, 1.2)

    ScrollTrigger.create({
      animation: timeline,
      trigger: '.About_item01',
      start: 'top 90%',
      toggleActions: 'play none none reverse',
    })
  }, [])

  const AboutList = list.map((item, index) => (
    <p key={index} className={styles.about_body_item}>
      {item.text}
    </p>
  ))

  const ExplainList = () => {
    if (!explain) return null

    return explain.map((item, index) => (
      <div key={index} className={styles.about_body_item_lists}>
        <p className={styles.about_body_item_lists_title}>{item.title}</p>
        <p className={styles.about_body_item_lists_explanation}>{item.explanation}</p>
      </div>
    ))
  }

  return (
    <section className={styles.wrapper}>
      <div className={styles.inner}>
        <TitleFlex sectionTitle={{ title: 'What we do', sub_title: '概要' }} />
        <div className={`${styles.about_body} About_item01`}>
          <div>{AboutList}</div>
          {ExplainList()}
        </div>
      </div>
    </section>
  )
}

export default About
